import { memo } from 'react';
import cn from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { ArrowIosLeftFill, ArrowIosRightOutline } from '@lyearn/icons';
import { IconButton } from '@lyearn/ui';

import { CarouselNavigationProps } from './types';

const NAVIGATION_CLASSES =
  'transform -translate-y-1/2 -translate-x-1/2 rtl:translate-x-1/2 absolute top-1/2 z-10 justify-center flex items-center carousel-navigation';

const DEFAULT_CLASSES = {
  leftArrow: cn('start-0 navigation-left-arrow', NAVIGATION_CLASSES),
  rightArrow: cn('start-full navigation-right-arrow', NAVIGATION_CLASSES),
};

const CarouselNavigation = (props: CarouselNavigationProps) => {
  const { t } = useTranslation();
  const {
    className,
    classes: classesProp,
    showLeftArrow,
    showRightArrow,
    onLeftArrowClick,
    onRightArrowClick,
  } = props;

  const classes = { ...DEFAULT_CLASSES, ...classesProp };

  if (!showLeftArrow && !showRightArrow) {
    return null;
  }

  return (
    <>
      {showLeftArrow ? (
        <IconButton
          Icon={ArrowIosLeftFill}
          appearance="secondary"
          aria-label={t('Common:Actions.Previous')}
          className={cn(className, classes.leftArrow, classes.leftArrowPosition, 'rtl:rotate-180')}
          size="xl"
          variant="shadow"
          onClick={onLeftArrowClick}
        />
      ) : null}
      {showRightArrow ? (
        <IconButton
          Icon={ArrowIosRightOutline}
          aria-label={t('Common:Actions.Next')}
          className={cn(
            className,
            classes.rightArrow,
            classes.rightArrowPosition,
            'rtl:rotate-180',
          )}
          size="xl"
          variant="shadow"
          onClick={onRightArrowClick}
        />
      ) : null}
    </>
  );
};

export default memo(CarouselNavigation);
